<template>
    <div id="chat">
        <h2><font-awesome-icon :icon="['far', 'comments']"></font-awesome-icon> Berichten</h2>
        <chat :assignmentId="parseInt(this.$route.params.id)" :disabled="completed"></chat>
    </div>
</template>

<script>
import Chat from '@/components/Chat';

export default {
        components: {
            Chat
        },
        methods: {
            
        },
        computed: {
            completed() {
                return this.$parent.completed;
            }
        }
    }

</script>